import { createSlice } from "@reduxjs/toolkit"
import client from "../../lib/client"
import { globalBatchFilesFilterUrl, globalBatchFilesUrl } from "../../lib/endpoints"
import { createFilterUrl } from "../../functions/objectFunctions/createFilterUrl"


const emptyState = {
    globalBatchFiles: [],
    total: 0,
    pagination: { current: 1, pageSize: 10, total: 0, },
    loading: false,
}

export const globalBatchFilesSlice = createSlice({
    name: "globalBatchFiles",
    initialState: emptyState,
    reducers:{
        setGlobalBatchFiles: (state, action) => {
            state.globalBatchFiles = action.payload.global_batch_files
            state.total = action.payload.total
        },
        setPagination: (state, action) => {
            state.pagination = action.payload
        },
        setLoading: (state, action) => {
            state.loading = action.payload
        }
    }
})

export const { setGlobalBatchFiles, setPagination, setLoading } = globalBatchFilesSlice.actions

export function fetchGlobalBatchFiles(pagination, sort = null){
    return async (dispatch, getState) => {
        dispatch(setLoading(true))
        let url = `${globalBatchFilesUrl}?page=${pagination.current}&per=${pagination.pageSize}`
        if (sort) {
            url += `&q[s]=${sort.column} ${sort.direction}`
        }
        const response = await client.get(url).catch((e) => {
            setLoading(false)
            return { error: e }
        })
        if(response.data.global_batch_files){
            dispatch(setGlobalBatchFiles(response.data))
            dispatch(setPagination(pagination))
        }
        dispatch(setLoading(false))
        return response
    }
}

export function filterFiles(query){
    let filterUrl = createFilterUrl(query, globalBatchFilesFilterUrl, '')
    return async (dispatch) => {
        dispatch(setLoading(true))
        const response = await client.get(filterUrl)
        dispatch(setGlobalBatchFiles(response.data))
        dispatch(setPagination(query.pagination))
        dispatch(setLoading(false))
    }
}

export const selectGlobalBatchFiles = (state) => state.globalBatchFiles.globalBatchFiles
export const selectPagination = (state) => state.globalBatchFiles.pagination
export const selectTotal = (state) => state.globalBatchFiles.total
export const selectLoading = (state) => state.globalBatchFiles.loading

export default globalBatchFilesSlice.reducer